import { useState } from 'react'
import { Search } from 'lucide-react'
import { fetchPayingAgentBoleto } from '../../services/api'
import Loader from '../../components/Loader'
import {
	Alert,
	Button,
	Card,
	CopyableId,
	DetailGrid,
	DetailItem,
	EmptyState,
	JsonViewer,
	PageHeader,
	TextInput,
	formatCurrency,
	statusTone,
	Badge,
} from '../../components/ui'

const PayingAgentBoleto = () => {
	const [boletoId, setBoletoId] = useState('')
	const [boleto, setBoleto] = useState(null)
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState('')
	const [searched, setSearched] = useState(false)

	const handleSubmit = async (e) => {
		e.preventDefault()
		setIsLoading(true)
		setError('')
		setBoleto(null)
		try {
			setBoleto(await fetchPayingAgentBoleto(boletoId.trim()))
		} catch (err) {
			setError(err.message)
		} finally {
			setSearched(true)
			setIsLoading(false)
		}
	}

	return (
		<div>
			<PageHeader
				title="Boletos da pagadoria"
				subtitle="GET /paying-agent/boletos/{id} — consulta de boleto por identificador"
			/>

			<Card className="mb-6">
				<form onSubmit={handleSubmit} className="flex flex-wrap items-end gap-4">
					<TextInput
						id="boletoId"
						label="ID do boleto"
						placeholder="44444444-4444-4444-4444-444444444444"
						required
						className="flex-1 min-w-[280px]"
						value={boletoId}
						onChange={(e) => setBoletoId(e.target.value)}
					/>
					<Button type="submit" disabled={isLoading}>
						{isLoading ? <Loader size="sm" /> : <Search className="h-4 w-4" />}
						Consultar
					</Button>
				</form>
			</Card>

			<Alert onDismiss={() => setError('')}>{error}</Alert>

			{isLoading ? (
				<div className="flex h-48 items-center justify-center">
					<Loader size="lg" />
				</div>
			) : boleto ? (
				<div className="space-y-6">
					<Card title="Dados do boleto">
						<DetailGrid>
							<DetailItem label="ID">
								<CopyableId value={boleto.id || boleto.publicId} />
							</DetailItem>
							<DetailItem label="Status">
								{boleto.status ? (
									<Badge tone={statusTone(boleto.status)}>{boleto.status}</Badge>
								) : null}
							</DetailItem>
							<DetailItem label="Valor">{formatCurrency(boleto.amount)}</DetailItem>
							<DetailItem label="Vencimento">{boleto.dueDate}</DetailItem>
							<DetailItem label="Nosso numero (banco)">{boleto.bankOurNumber}</DetailItem>
							<DetailItem label="Nosso numero (cliente)">{boleto.clientOurNumber}</DetailItem>
							<DetailItem label="Linha digitavel">
								<CopyableId value={boleto.digitableLine} />
							</DetailItem>
							<DetailItem label="Codigo de barras">
								<CopyableId value={boleto.barcode} />
							</DetailItem>
						</DetailGrid>
					</Card>

					<Card title="Resposta bruta">
						<JsonViewer data={boleto} />
					</Card>
				</div>
			) : searched && !error ? (
				<EmptyState message="Boleto nao encontrado" />
			) : null}
		</div>
	)
}

export default PayingAgentBoleto
